import { render, staticRenderFns } from "./MisSolicitudes.vue?vue&type=template&id=140b6ff6"
import script from "./MisSolicitudes.vue?vue&type=script&lang=js"
export * from "./MisSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports